import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-20 lg:pt-20 lg:pb-28 overflow-hidden bg-brand-50" data-id="element-118">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-120">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-100 text-brand-800 font-semibold text-sm mb-6" data-id="element-121">
            <span data-id="element-122">🩺</span> Para vos, psicopedagoga
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-10 tracking-tight" data-id="element-123">
            Todo tu material psicopedagógico{' '}
            <span className="text-brand-600" data-id="element-124">listo para usar</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mb-10" data-id="element-125">
          <div className="absolute inset-0 bg-brand-400 rounded-full blur-3xl opacity-20 transform scale-75" data-id="element-126"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rpBkHQUrJsRJGkaHxE7yX6/pasted-image.png" alt="MegaPack Psicopedagogía" className="relative z-10 w-full max-w-2xl mx-auto drop-shadow-2xl" data-id="element-127" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-128">
          <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-129">
            Ahorrá horas de planificación con recursos imprimibles para consulta
            o clase.
          </p>

          <div className="flex items-center justify-center gap-2 mb-8 flex-wrap" data-id="element-130">
            <div className="flex text-accent" data-id="element-131">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-132" />)}
            </div>
            <span className="font-bold text-gray-800" data-id="element-133">4.9/5</span>
            <span className="text-gray-500 hidden sm:inline" data-id="element-134">·</span>
            <span className="text-gray-600" data-id="element-135">
              Elegido por +2.400 psicopedagogas
            </span>
          </div>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-600 hover:bg-brand-700 text-white text-lg font-bold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-3 mb-10" data-id="element-136">
            <span className="text-2xl" data-id="element-137">🧮</span> ACCEDER AL MATERIAL
          </button>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-138">
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-139">
              <span data-id="element-140">📄</span> Plantillas listas para usar
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-141">
              <span data-id="element-142">⚡</span> Ahorrá horas de planificación
            </div>
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700 bg-white px-4 py-2 rounded-lg shadow-sm border border-gray-100" data-id="element-143">
              <span data-id="element-144">📊</span> Informes y seguimiento más rápidos
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}